import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useTooltip from "../../hooks/useTooltip/useTooltip";
import { Flex } from "../Box";
var InfoTooltip = function(_param) {
    var text = _param.text, _iconColor = _param.iconColor, iconColor = _iconColor === void 0 ? "textSubtle" : _iconColor, props = _object_without_properties(_param, [
        "text",
        "iconColor"
    ]);
    var ref = useTooltip(text, {}), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ _jsxs(Flex, _object_spread_props(_object_spread({}, props), {
        alignItems: "center",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ _jsx(Flex, {
                ref: targetRef,
                alignItems: "center",
                children: /*#__PURE__*/ _jsx("img", {
                    alt: "info",
                    src: "/images/leaderboard/infoIcon.svg"
                })
            })
        ]
    }));
};
export default InfoTooltip;
